import { render, staticRenderFns } from "./WsStateSwitch.vue?vue&type=template&id=56cadced&"
import script from "./WsStateSwitch.vue?vue&type=script&lang=js&"
export * from "./WsStateSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports